/**
 * Centrální konfigurace obchodu.
 * Pro nový obchod stačí změnit hodnoty v tomto souboru.
 */
const SHOP_CONFIG = {
  name: 'OFFICEbasic',
  domain: 'OFFICEbasic.cz',
  url: 'https://officebasic.cz',
  tagline: 'Kancelarske potreby pro vasi firmu',
  description: 'Vice nez 35 000 produktu skladem. Rychle dodani, skvele ceny.',
  footerText: 'Váš spolehlivý partner pro kancelářské potřeby. Více než 35 000 produktů skladem.',
  seoDefault: 'Kancelářské potřeby',
  productCount: '35 000+',
  features: [
    { title: 'Siroky sortiment', desc: 'Vice nez 35 000 produktu' },
    { title: 'Rychle dodani', desc: 'Expedice do 24 hodin' },
    { title: 'Skvele ceny', desc: 'Velkoobchodni ceny pro vsechny' },
  ],
  colors: {
    primary: '#004E98',
    primaryDark: '#003B73',
    accent: '#FF6B35',
  },
  contact: {
    defaultPhone: '+420 272 700 799',
    defaultEmail: 'info@officebasic.cz',
  },
  company: {
    name: 'Reguli s.r.o.',
  },
};

export default SHOP_CONFIG;
